module.exports = __webpack_public_path__ + "static/media/pagamento.4917223e.svg";